// extracted by mini-css-extract-plugin
export default {"ToolsPanel":"ToolsPanel_ToolsPanel__HViSQ","icon":"ToolsPanel_icon__L7Uwb","counter":"ToolsPanel_counter__ZVi1d"};